import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { SingleDatePicker } from "react-dates";
import moment from "moment";
import * as CategoryActions from "@modules/categoryGroupsManagement";
import Categories from "../../routes/categories/Categories";
import { bindActionCreators } from "redux";
import { CATEGORY_TYPES, PUBLIC_URL, LIMIT_BYTE } from "@constants";
import RangePicker from "../datepicker/RangePicker";
import AttributionInputArea from "../inputArea/AttributionInputArea";
import HashtagInputArea from "../inputArea/HashtagInputArea";
import Textarea from "../input/Textarea";
import InputField from "../input/InputField";
import validateInput from "../../cores/validateInput";
import limitMaxLength from "../../cores/limitMaxLength";
import fieldTypeEnum from "../../cores/fieldTypeEnum";
import WithSelect from "../select/Select";

import equal from "deep-equal";
import { ImageCategoryGroupOn } from "@mzc-cloudplex/icons";
import MetadataUseStatusTooltip from "../tooltip/MetadataUseStatusTooltip";
import compareVersions, { VERSION_CM_10877_ASSET_CUSTOM_METADATA } from "@cores/version";

class MetadataView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isShowEditBox: false,
            data: {},
            value: {},
            values: [],
            validationErrors: {},
            metadataSchemaFieldsFocused: [],
            categoryGroupTooltipDisabled: true,
        };
    }

    lastState = null;

    onChangeCategories = (categories) => {
        this.setState({
            data: {
                ...this.state.data,
                categories: categories.categories.map((c) => {
                    return {
                        id: c.value,
                        name: c.label,
                        categoryGroup: { id: categories.categoryGroup.id },
                    };
                }),
                categoryGroup: categories.categoryGroup,
            },
        });
    };

    componentDidMount = () => {
        this.setData();
        this.getCategoryGroup(this.props.categories, "value");
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (!equal(prevProps, this.props)) {
            this.setData();

            if (!equal(prevProps.categories, this.props.categories)) {
                this.getCategoryGroup(this.props.categories, "value");
            }
        }

        // console.log(prevProps.state.categoryGroupTooltipDisabled);
        // console.log(this.state.categoryGroupTooltipDisabled);
        // console.log(prevState);

        // if (prevState.value?.categoryGroup?.id === this.state.value?.categoryGroup?.id) {
        //     this.state.categoryGroupTooltipDisabled = true;
        // }

        // console.log(this.state.categoryGroupTooltipDisabled);
    };

    setData = () => {
        const { createdBy, stage } = this.props;

        const loginUserId = stage && stage.user && stage.user.id;
        const resourceOwnerId = createdBy && createdBy.id;

        this.setState({
            ...this.state,
            isResourceOwner: loginUserId ? loginUserId === resourceOwnerId : false,
            value: { ...this.state.value, ...this.props },
        });
    };

    onClickCancelEditField = (key) => {
        this.hiddenEditBox(key);
    };

    onClickSaveField = (key) => {
        const oldKey = key;

        let value = this.state.data[key];
        // console.log("key :>> ", key);
        // console.log("value :>> ", value);

        this.props.onClickSaveField(key, value);

        if (key.indexOf(`metadata-schema-field-`) > -1) {
            value = this.isMetaDataValue(key, value);
            key = "metadataSchemas";
        }

        let state = {
            ...this.state,
            value: {
                ...this.state.value,
                [key]: value,
            },
        };

        let categoryGroupTooltip = this.props.tooltipDisabled;

        if (!categoryGroupTooltip) {
            if (state.value.categoryGroup?.id === this.state.data.categoryGroup?.id) {
                categoryGroupTooltip = !categoryGroupTooltip;
            }
        }

        // console.log(categoryGroupTooltip);

        if (key === "categories" && this.state.data.categoryGroup) {
            state.value.categoryGroup = this.state.data.categoryGroup;
            state.categoryGroupTooltipDisabled = categoryGroupTooltip;
        }

        this.setState(state);

        if (oldKey !== key) key = oldKey;

        this.hiddenEditBox(key);
    };

    onClickEditField = (key, value) => {
        const state = {
            isShowEditBox: true,
            data: {
                ...this.state.data,
                [key]: value,
            },
        };

        if (key === "categories") state.data.categoryGroup = this.state.value.categoryGroup;

        this.lastState = state;
        this.setState(state);
    };

    onInputAddTag = (value) => {
        const tags = this.state.data.tags || [];

        this.setState({
            data: {
                ...this.state.data,
                tags: tags.concat({ value }),
            },
        });
    };

    onInputRemoveTag = (index) => {
        this.setState({
            data: {
                ...this.state.data,
                tags: this.state.data.tags.filter((v, i) => i !== index),
            },
        });
    };

    onChangeAttributionValue = (id, value, validationError) => {
        this.updateAttribution(
            id,
            { value },
            {
                [`attribution-${id}-value`]: validationError,
            },
        );
    };

    onChangeAttributionKey = (id, key, validationError) => {
        this.updateAttribution(
            id,
            { key },
            {
                [`attribution-${id}-key`]: validationError,
            },
        );
    };

    onChangeData = async (key, value, validationError) => {
        const state = {
            ...this.state,
            ...this.lastState,
            data: {
                ...this.state.data,
                [key]: value,
            },
            validationErrors: {
                ...this.state.validationErrors,
                [key]: validationError,
            },
        };
        this.lastState = state;
        this.setState(state);
    };

    onChangeDescription = (description) => {
        this.onChangeData(
            "description",
            description,
            validateInput(description, {
                maxByte: LIMIT_BYTE.description,
            }),
        );
    };

    onClickAddAttribution = (id, validationError) => {
        const attributions = this.state.data.attributions || [];

        this.setState({
            data: {
                ...this.state.data,
                attributions: attributions.concat([{ id, key: "", value: "" }]),
            },
            validationErrors: {
                ...this.state.validationErrors,
                [`attribution-${id}-key`]: validationError,
                [`attribution-${id}-value`]: validationError,
            },
        });
    };

    onClickRemoveAttribution = (id) => {
        this.setState({
            data: {
                ...this.state.data,
                attributions: this.state.data.attributions.filter((a) => a.id !== id),
            },
            validationErrors: {
                ...this.state.validationErrors,
                [`attribution-${id}-key`]: undefined,
                [`attribution-${id}-value`]: undefined,
            },
        });
    };

    updateAttribution = (id, data, validationError) => {
        this.setState({
            data: {
                attributions: this.state.data.attributions.map((a) => {
                    if (a.id === id) {
                        return {
                            ...a,
                            ...data,
                        };
                    }

                    return a;
                }),
            },
            validationErrors: {
                ...this.state.validationErrors,
                ...validationError,
            },
        });
    };

    hiddenEditBox = (key) => {
        const data = this.state.data;
        delete data[key];
        this.setState({
            isShowEditBox: Object.keys(data).length > 0,
            data,
        });
    };

    isShowEditBox = (key) => {
        return this.state.isShowEditBox && this.state.data.hasOwnProperty(key);
    };

    isMetaDataValue = (key, value) => {
        const fieldId = key.replace("metadata-schema-field-", "");
        const metadataSchemas = JSON.parse(JSON.stringify(this.state.value.metadataSchemas));

        metadataSchemas.map((schema) => {
            schema.fields.map((f) => {
                if (f.id == fieldId) {
                    f.value = value;
                }
            });
        });

        return metadataSchemas;
    };

    onClickGetHiddenFieldValue = (metadataSchemaId, metadataFieldId, metadataId) => {
        this.props.onClickGetHiddenFieldValue(metadataSchemaId, metadataFieldId, metadataId);
    };

    getMetadataFieldValue = (f, t) => {
        if (f.type !== "SELECT_MULTI") {
            if (f.value !== "") return f.value;
            else return t(`common::label::${"None"}`);
        } else {
            if (f.values && f.values.length > 0) return f.values.join(", ");
            else return t(`common::label::${"None"}`);
        }
    };

    getCategoryGroup = async (categories, key) => {
        if (!categories || categories?.length == 0) return;
        const { project, CategoryActions } = this.props;

        let categoryGroupId = categories[0]?.categoryGroup?.id || categories[0]?.categoryGroupId;

        const categoryGroupInfo = await CategoryActions.getCategoryGroup(project.id, categoryGroupId);

        if (categoryGroupInfo) {
            this.setState({
                ...this.state,
                [key]: {
                    ...this.state[key],
                    categoryGroup: { id: categoryGroupInfo.id, label: categoryGroupInfo.name },
                },
            });
        }
    };

    render() {
        const { t, i18n } = this.props;
        // console.log(this.props);
        // console.log("this.state.isResourceOwner :>> ", this.state.isResourceOwner);

        return (
            <div className={`list-overview ${this.props.isColumn && "column"}`}>
                <ul>
                    {this.props.description !== undefined && (
                        <li>
                            <div className="title">
                                <strong>{t(`common::label::${"Description"}`)}</strong>
                                {this.props.isEditable && !this.isShowEditBox("description") && (
                                    <button
                                        type={"button"}
                                        className={"btn btn-icon-solid btn-edit"}
                                        onClick={() => {
                                            this.onClickEditField("description", this.state.value.description);
                                        }}
                                    >
                                        <i className={"sprite sprite-edit"}></i>
                                    </button>
                                )}
                            </div>
                            <div className="content">
                                {this.isShowEditBox("description") ? (
                                    <React.Fragment>
                                        <Textarea
                                            wrapperClass="box"
                                            isEdit={true}
                                            value={this.state.data.description}
                                            placeholder={t(`common::label::${"Description"}`)}
                                            maxByte={LIMIT_BYTE.description}
                                            validationError={this.state.validationErrors.description}
                                            onChange={(e) => {
                                                this.onChangeDescription(e.target.value);
                                            }}
                                        />
                                        <div className="btns-editable">
                                            <button
                                                type={"button"}
                                                className={"btn btn-icon btn-sm"}
                                                onClick={() => {
                                                    this.onClickCancelEditField("description");
                                                }}
                                            >
                                                <i className={"sprite sprite-edit-cancel"} />
                                            </button>
                                            <button
                                                type={"button"}
                                                className={"btn btn-icon btn-sm btn-outline-primary"}
                                                disabled={this.state.validationErrors.description}
                                                onClick={() => {
                                                    this.onClickSaveField("description");
                                                }}
                                            >
                                                <i className={"sprite sprite-edit-submit"} />
                                            </button>
                                        </div>
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        {this.state.value.description ? (
                                            <span>{this.state.value.description}</span>
                                        ) : (
                                            <span className={"text-cancel"}>{t(`common::label::${"None"}`)}</span>
                                        )}
                                    </React.Fragment>
                                )}
                            </div>
                        </li>
                    )}
                    <li>
                        <div className="title">
                            <strong>{t(`common::label::${"Categories"}`)}</strong>
                            {this.props.isEditable && !this.isShowEditBox("categories") && (
                                <button
                                    type={"button"}
                                    className={"btn btn-icon-solid btn-edit"}
                                    onClick={() => {
                                        this.onClickEditField("categories", this.state.value.categories);
                                    }}
                                >
                                    <i className={"sprite sprite-edit"}></i>
                                </button>
                            )}
                        </div>

                        <div className="content">
                            {this.isShowEditBox("categories") ? (
                                <React.Fragment>
                                    <div className="form-stack box-border box-border-sm  box-border-radius is-edit">
                                        <Categories
                                            categoryGroups={true}
                                            selectedCategoryGroup={this.state.data.categoryGroup}
                                            type={this.props.categoryType || CATEGORY_TYPES.ASSET}
                                            placeholder={t(`common::label::${"Select category"}`)}
                                            selectedValues={
                                                this.state.data.categories &&
                                                this.state.data.categories.map((c) => {
                                                    return {
                                                        label: c.name,
                                                        name: c.name,
                                                        value: c.id,
                                                        id: c.id,
                                                    };
                                                })
                                            }
                                            onChange={(options) => {
                                                this.onChangeCategories(options);
                                            }}
                                        />
                                    </div>
                                    <div className="btns-editable">
                                        <button
                                            type={"button"}
                                            className={"btn btn-icon btn-sm"}
                                            onClick={() => {
                                                this.onClickCancelEditField("categories");
                                            }}
                                        >
                                            <i className={"sprite sprite-edit-cancel"} />
                                        </button>
                                        <button
                                            type={"button"}
                                            className={"btn btn-icon btn-sm btn-outline-primary"}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                // console.log(
                                                //     equal(
                                                //         this.state.value.categoryGroup?.id,
                                                //         this.state.data.categoryGroup?.id,
                                                //     ),
                                                // );
                                                // this.setState({
                                                //     ...this.state,
                                                //     categoryGroupTooltipDisabled: equal(
                                                //         this.state.value.categoryGroup?.id,
                                                //         this.state.data.categoryGroup?.id,
                                                //     ),
                                                // });

                                                this.onClickSaveField("categories");
                                            }}
                                        >
                                            <i className={"sprite sprite-edit-submit"} />
                                        </button>
                                    </div>
                                </React.Fragment>
                            ) : (
                                <>
                                    {this.state.value.categories && this.state.value.categories.length > 0 ? (
                                        <>
                                            <div className="form-label d-flex align-items-center">
                                                <ImageCategoryGroupOn width={16} height={16} />
                                                <strong style={{ marginLeft: `8px` }}>
                                                    {this.state.value.categoryGroup?.label}
                                                </strong>
                                                <MetadataUseStatusTooltip
                                                    tooltipDisabled={this.state.categoryGroupTooltipDisabled}
                                                    anchorOrigin={{
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    }}
                                                    transformOrigin={{
                                                        vertical: "top",
                                                        horizontal: "left",
                                                    }}
                                                    type={"right-start"}
                                                    activeTab={this.props.activeTab}
                                                    categoryGroupId={this.state.value.categoryGroup?.id}
                                                    categoryType={this.state.value.categoryType}
                                                />
                                            </div>
                                            <span hidden={this.isShowEditBox("categories")}>
                                                {this.state.value.categories.map((v) => v.name).join(", ")}
                                            </span>
                                        </>
                                    ) : (
                                        <span className={"text-cancel"}>{t(`common::label::${"None"}`)}</span>
                                    )}
                                </>
                            )}
                        </div>
                    </li>

                    <li>
                        <div className="title">
                            <strong>{t(`common::label::${"Attributions"}`)}</strong>
                            {this.props.isEditable && !this.isShowEditBox("attributions") && (
                                <button
                                    type={"button"}
                                    className={"btn btn-icon-solid btn-edit"}
                                    onClick={() => {
                                        this.onClickEditField("attributions", this.state.value.attributions);
                                    }}
                                >
                                    <i className={"sprite sprite-edit"}></i>
                                </button>
                            )}
                        </div>
                        <div className="content">
                            {this.isShowEditBox("attributions") ? (
                                <React.Fragment>
                                    <div className={"box-border box-border-sm box-border-radius is-edit"}>
                                        <AttributionInputArea
                                            values={this.state.data.attributions}
                                            onChangeKey={(id, value, validationError) => {
                                                this.onChangeAttributionKey(id, value, validationError);
                                            }}
                                            onChangeValue={(id, e, validationError) => {
                                                this.onChangeAttributionValue(id, e, validationError);
                                            }}
                                            onClickAddAttribution={(id, validationError) => {
                                                this.onClickAddAttribution(id, validationError);
                                            }}
                                            onClickRemoveAttribution={(id) => {
                                                this.onClickRemoveAttribution(id);
                                            }}
                                        />
                                    </div>
                                    <div className="btns-editable">
                                        <button
                                            type={"button"}
                                            className={"btn btn-icon btn-sm"}
                                            onClick={() => {
                                                this.onClickCancelEditField("attributions");
                                            }}
                                        >
                                            <i className={"sprite sprite-edit-cancel"} />
                                        </button>
                                        <button
                                            type={"button"}
                                            className={"btn btn-icon btn-sm btn-outline-primary"}
                                            disabled={
                                                Object.keys(this.state.validationErrors).filter(
                                                    (k) =>
                                                        k.indexOf("attribution") > -1 && this.state.validationErrors[k],
                                                ).length > 0
                                            }
                                            onClick={() => {
                                                this.onClickSaveField("attributions");
                                            }}
                                        >
                                            <i className={"sprite sprite-edit-submit"} />
                                        </button>
                                    </div>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    {this.state.value.attributions && this.state.value.attributions.length > 0 ? (
                                        <ul className="tags-info">
                                            {this.state.value.attributions.map((a, i) => (
                                                <li key={i}>
                                                    <strong>{a.key}</strong> :{" "}
                                                    <span className="text-secondary">{a.value}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <span className={"text-cancel"}>{t(`common::label::${"None"}`)}</span>
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                    </li>

                    <li>
                        <div className="title">
                            <strong>{t(`common::label::${"Tags"}`)}</strong>
                            {this.props.isEditable && !this.isShowEditBox("tags") && (
                                <button
                                    type={"button"}
                                    className={"btn btn-icon-solid btn-edit"}
                                    onClick={() => {
                                        this.onClickEditField("tags", this.state.value.tags || []);
                                    }}
                                >
                                    <i className={"sprite sprite-edit"}></i>
                                </button>
                            )}
                        </div>

                        <div className="content">
                            {this.isShowEditBox("tags") ? (
                                <React.Fragment>
                                    <HashtagInputArea
                                        isEdit={true}
                                        values={this.state.data.tags.map((v) => v.value)}
                                        onInputAddTag={this.onInputAddTag}
                                        onInputRemoveTag={this.onInputRemoveTag}
                                        onChangeInput={(e, validationError) => {
                                            // ToDO : validation
                                            // this.props.MetadataActions.setValidationError({
                                            //     key : 'hashtag',
                                            //     error : validationError
                                            // });
                                        }}
                                    />

                                    <div className="btns-editable">
                                        <button
                                            type={"button"}
                                            className={"btn btn-icon btn-sm"}
                                            onClick={() => {
                                                this.onClickCancelEditField("tags");
                                            }}
                                        >
                                            <i className={"sprite sprite-edit-cancel"} />
                                        </button>
                                        <button
                                            type={"button"}
                                            className={"btn btn-icon btn-sm btn-outline-primary"}
                                            onClick={() => {
                                                this.onClickSaveField("tags");
                                            }}
                                        >
                                            <i className={"sprite sprite-edit-submit"} />
                                        </button>
                                    </div>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    {this.state.value.tags && this.state.value.tags.length > 0 ? (
                                        <div className={"list-tags"}>
                                            {this.state.value.tags
                                                .sort((a, b) => a.value.localeCompare(b.value))
                                                .map((t, i) => (
                                                    <span key={`${i}_${t.id}`} className={"tag"}>
                                                        {/* ToDO AI에서 추출된 경우는 class ai 추가 */}
                                                        {t.value}
                                                    </span>
                                                ))}
                                        </div>
                                    ) : (
                                        <span className={"text-cancel"}>{t(`common::label::${"None"}`)}</span>
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                    </li>
                </ul>
                <hr />
                {(this.props.categoryType === CATEGORY_TYPES.VIDEO ||
                    (this.props.categoryType === CATEGORY_TYPES.ASSET &&
                        ["IMAGE", "MP4", "THUMBNAILS", "DASH"].indexOf(this.props.type) >= 0)) && (
                    <React.Fragment>
                        <ul>
                            <li>
                                <div className="title">
                                    <strong>{t(`common::label::${"People"}`)}</strong>
                                </div>

                                <div className="content">
                                    {this.props.people && this.props.people.length > 0 ? (
                                        <React.Fragment>
                                            <div className={"list-image list-image-sm list-image-half"}>
                                                <ul>
                                                    {this.props.people.map((p, i) => (
                                                        <li key={`people-${i}`}>
                                                            <div className="content">
                                                                <span className={"image"}>
                                                                    <img
                                                                        src={
                                                                            p.accessUrl ||
                                                                            `${PUBLIC_URL}/images/thumbnail_no_image.png`
                                                                        }
                                                                        onError={(e) => {
                                                                            e.target.src = `${PUBLIC_URL}/images/thumbnail_no_image.png`;
                                                                        }}
                                                                    />
                                                                </span>
                                                                <p>{p.name}</p>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </React.Fragment>
                                    ) : (
                                        <span className={"text-cancel"}>{t(`common::label::${"None"}`)}</span>
                                    )}
                                </div>
                            </li>
                        </ul>
                        <hr />
                    </React.Fragment>
                )}
                <ul>
                    {this.state.value.metadataSchemas &&
                        this.state.value.metadataSchemas.map(
                            (v, i) =>
                                v.fields &&
                                v.fields.map((f, k) => (
                                    <li key={`${i}-${k}`}>
                                        <div className="title">
                                            <strong>{f.name}</strong>
                                            {(!f.isHidden || this.state.isResourceOwner || f.isCheckHiddenValue) &&
                                                this.props.isEditable &&
                                                !this.isShowEditBox(`metadata-schema-field-${f.id}`) && (
                                                    <button
                                                        type={"button"}
                                                        className={"btn btn-icon-solid btn-edit"}
                                                        onClick={() => {
                                                            this.onClickEditField(
                                                                `metadata-schema-field-${f.id}`,
                                                                f.type !== "SELECT_MULTI" ? f.value : f.values || [],
                                                            );
                                                        }}
                                                        style={{ height: "auto", marginBottom: "2px" }}
                                                    >
                                                        <i className={"sprite sprite-edit"}></i>
                                                    </button>
                                                )}
                                        </div>

                                        <div className="content">
                                            {this.isShowEditBox(`metadata-schema-field-${f.id}`) ? (
                                                <React.Fragment>
                                                    {compareVersions(
                                                        this.props.stage.version,
                                                        VERSION_CM_10877_ASSET_CUSTOM_METADATA,
                                                    ) < 0 && this.props.type === "Asset"
                                                        ? null
                                                        : this.renderCustomField(f)}
                                                    <div className="btns-editable">
                                                        <button
                                                            type={"button"}
                                                            className={"btn btn-icon btn-sm"}
                                                            onClick={() => {
                                                                this.onClickCancelEditField(
                                                                    `metadata-schema-field-${f.id}`,
                                                                );
                                                            }}
                                                        >
                                                            <i className={"sprite sprite-edit-cancel"} />
                                                        </button>
                                                        <button
                                                            type={"button"}
                                                            className={"btn btn-icon btn-sm btn-outline-primary"}
                                                            onClick={() => {
                                                                this.onClickSaveField(`metadata-schema-field-${f.id}`);
                                                            }}
                                                        >
                                                            <i className={"sprite sprite-edit-submit"} />
                                                        </button>
                                                    </div>
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <span
                                                        className={`${
                                                            (!f.isHidden || f.isCheckHiddenValue) &&
                                                            (f.value || (f.values && f.values.length > 0))
                                                                ? "vertical-middle"
                                                                : "text-cancel"
                                                        }`}
                                                    >
                                                        {f.isHidden &&
                                                        !this.state.isResourceOwner &&
                                                        !f.isCheckHiddenValue ? (
                                                            <React.Fragment>
                                                                <span className="text-hidden">
                                                                    &middot;&middot;&middot;&middot;&middot;
                                                                </span>
                                                            </React.Fragment>
                                                        ) : (
                                                            <React.Fragment>
                                                                {this.getMetadataFieldValue(f, t)}
                                                            </React.Fragment>
                                                        )}
                                                    </span>
                                                    {f.isHidden && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-icon-solid btn-toggle-value"
                                                            disabled={
                                                                this.state.isResourceOwner || f.isCheckHiddenValue
                                                            }
                                                            onClick={(e) => {
                                                                this.onClickGetHiddenFieldValue(
                                                                    v.id,
                                                                    f.id,
                                                                    f.metadataId,
                                                                );
                                                            }}
                                                        >
                                                            {f.pending ? (
                                                                <i className="sprite sprite sprite-loading"></i>
                                                            ) : (
                                                                <i className="sprite sprite-view-show"></i>
                                                            )}
                                                            {/* <i className="sprite sprite-view-show"></i> */}
                                                            {/* <i className="sprite sprite-view-hide"></i> */}
                                                        </button>
                                                    )}
                                                </React.Fragment>
                                            )}
                                        </div>
                                    </li>
                                )),
                        )}
                </ul>
            </div>
        );
    }

    // ToDO :  custom field 랑 합쳐야함. ENUM 값이 달라서 일단은 여기다 둠
    renderCustomField = (field) => {
        const key = `metadata-schema-field-${field.id}`;
        const fieldEnum = Object.freeze(fieldTypeEnum);
        const validationError = validateInput(this.state.data[key], {
            required: false,
            maxByte: fieldEnum[field.type],
        });
        switch (field.type) {
            case "TEXT_FIELD":
            case "NUMBER":
                return (
                    <InputField
                        isEdit={true}
                        type={field.type === "NUMBER" ? "number" : "text"}
                        wrapperClass="box box-in-input"
                        value={this.state.data[key]}
                        validationError={validationError}
                        onChange={(e) => {
                            limitMaxLength(e, this.state.data[key], LIMIT_BYTE.comment);
                            this.onChangeData(key, e.target.value);
                        }}
                    />
                );
            case "TEXT_AREA":
                return (
                    <Textarea
                        isEdit={true}
                        wrapperClass="textarea"
                        value={this.state.data[key]}
                        placeholder={field.name}
                        validationError={validationError}
                        onChange={(e) => {
                            limitMaxLength(e, this.state.data[key], LIMIT_BYTE.description);
                            this.onChangeData(key, e.target.value);
                        }}
                    />
                );
            case "DATE_PICKER_SINGLE":
                return (
                    <SingleDatePicker
                        isEdit={true}
                        date={this.state.data[key] ? moment(this.state.data[key]) : null}
                        onDateChange={(date) => {
                            this.onChangeData(key, date ? moment(date).format("YYYY-MM-DD") : "");
                        }}
                        displayFormat={"YYYY-MM-DD"}
                        isOutsideRange={() => false}
                        focused={
                            this.state.metadataSchemaFieldsFocused[key] &&
                            this.state.metadataSchemaFieldsFocused[key].focused
                        }
                        onFocusChange={({ focused }) => {
                            const state = {
                                ...this.state,
                                ...this.lastState,
                            };

                            state.metadataSchemaFieldsFocused[key] = {
                                ...state.metadataSchemaFieldsFocused[key],
                                focused,
                            };

                            this.lastState = state;
                            this.setState(state);
                        }}
                        numberOfMonths={1}
                        small={true}
                        showDefaultInputIcon={true}
                        inputIconPosition="before"
                        anchorDirection={"right"}
                    />
                );
            case "DATE_PICKER_RANGE":
                return (
                    <RangePicker
                        isEdit={true}
                        startDate={
                            this.state.data[key] && this.state.data[key].split("~")[0]
                                ? moment(this.state.data[key].split("~")[0])
                                : null
                        }
                        endDate={
                            this.state.data[key] && this.state.data[key].split("~")[1]
                                ? moment(this.state.data[key].split("~")[1])
                                : null
                        }
                        displayFormat={"YYYY-MM-DD"}
                        isOutsideRange={() => false}
                        onDatesChange={({ startDate, endDate }) => {
                            const dateRange = `${startDate ? moment(startDate).format("YYYY-MM-DD") : ""}~${
                                endDate ? moment(endDate).format("YYYY-MM-DD") : ""
                            }`;
                            this.onChangeData(key, dateRange === "~" ? "" : dateRange);
                        }}
                    />
                );
            case "SELECT_SINGLE":
            case "SELECT_MULTI":
                const dict = {};
                field.itemSet.map((v) => {
                    dict[v] = "";
                });

                if (field.type === "SELECT_SINGLE") dict[this.state.data[key]] = "";
                else {
                    this.state.data[key].map((v) => {
                        dict[v] = "";
                    });
                }

                const options = Object.keys(dict).map((v) => {
                    return {
                        value: v,
                        label: v,
                    };
                });

                return (
                    <div className={""}>
                        <WithSelect
                            defaultValue={
                                field.type === "SELECT_SINGLE"
                                    ? this.state.data[key]
                                    : this.state.data[key].map((v) => {
                                          return { label: v, value: v };
                                      })
                            }
                            options={options}
                            isMulti={field.type === "SELECT_SINGLE" ? false : true}
                            hideSelectedOptions={false}
                            onChange={(option) => {
                                if (field.type === "SELECT_SINGLE") this.onChangeData(key, option.value);
                                else
                                    this.onChangeData(
                                        key,
                                        option && option.length > 0 ? option.map((v) => v.value) : [],
                                    );
                            }}
                        />
                    </div>
                );
            default:
                return <div></div>;
        }
    };
}

let mapStateToProps = (state) => {
    return {
        stage: state.stage,
        project: state.project,
    };
};

let mapDispatchToProps = (dispatch) => {
    return {
        CategoryActions: bindActionCreators(CategoryActions, dispatch),
    };
};

MetadataView = connect(mapStateToProps, mapDispatchToProps)(MetadataView);
export default withTranslation()(MetadataView);
